var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.481 0H8.53333C3.08622 0 0 3.08622 0 8.53333V23.4667C0 28.9138 3.08622 32 8.53333 32H23.481C28.928 32 32 28.9138 32 23.4667V8.53333C32 3.08622 28.928 0 23.481 0Z",
    fill: "#CE2600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.0953 14.3249C21.0953 14.3702 20.74 18.864 20.5371 20.7553C20.41 21.9159 19.6618 22.6199 18.5395 22.6399C17.6771 22.6592 16.8329 22.6659 16.0024 22.6659C15.1206 22.6659 14.2583 22.6592 13.4212 22.6399C12.3365 22.6139 11.5876 21.8959 11.467 20.7553C11.2583 18.8574 10.9095 14.3702 10.903 14.3249C10.8965 14.1882 10.9406 14.0582 11.03 13.9529C11.1182 13.8555 11.2453 13.7969 11.3789 13.7969H20.6259C20.7588 13.7969 20.8794 13.8555 20.9747 13.9529C21.0635 14.0582 21.1083 14.1882 21.0953 14.3249Z",
    fill: "#CE2600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.9833C22 11.7093 21.7841 11.4946 21.5247 11.4946H19.5809C19.1854 11.4946 18.8418 11.2133 18.7536 10.8166L18.6447 10.3307C18.4923 9.74335 17.9665 9.33203 17.3765 9.33203H14.6242C14.0277 9.33203 13.507 9.74335 13.3488 10.3627L13.247 10.8173C13.1582 11.2133 12.8146 11.4946 12.4197 11.4946H10.4759C10.2159 11.4946 10 11.7093 10 11.9833V12.2366C10 12.5039 10.2159 12.7252 10.4759 12.7252H21.5247C21.7841 12.7252 22 12.5039 22 12.2366V11.9833Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.91c01291e94c26e7cdaf52e7fb76802e.svg";
export { ForwardRef as ReactComponent };